import { useLocalStorage } from "./localStorage";
import settingsApp from "./settings";
import httpApp from "./http";
import { useMainStore } from "@/stores/main";
import { useCartStore } from "@/stores/cart";
import { useGlobalFunctions } from "@/libs/globalFunctions";

import i18n from "@/i18n";
const { t, te } = i18n.global;

const { createLoading, openToast } = useGlobalFunctions();

const { getLocalStorageData } = useLocalStorage();

const cartApp = {
	getQuote: async (showLoading = false) => {
		const loading = await createLoading(t("pleaseWait"));
		if (showLoading) {
			loading.present();
		}
		return new Promise(function (resolve, reject) {
			const minimumOrderAmount = getLocalStorageData("minimumAmount")
				? Number(getLocalStorageData("minimumAmount"))
				: 0;
			const cartStore = useCartStore();
			httpApp
				.sendGetRequest(settingsApp.getEndpointUrl("getQuote"))
				.then((response: any) => {
					if (
						!Object.prototype.hasOwnProperty.call(response, "error")
					) {
						const quote = response;
						const subtotal = Number(quote.subtotal);
						const discount =
							Number(subtotal) -
							Number(quote.subtotal_with_discount);
						const deliveryFees =
							Number(quote.delivery_fees) ||
							Number(quote.shipping_amount);
						const grandTotal = Number(quote.grand_total);

						const returnData = {
							quote: quote,
							showMinimumMsg:
								minimumOrderAmount > subtotal ? true : false,
							subtotal: subtotal,
							deliveryFees: deliveryFees,
							discount: discount,
							grandTotal: grandTotal,
						};
						cartStore.setCartTotals(returnData);
						if (response.delivery_date != "0000-00-00 00:00:00") {
							cartStore.setDeliveryDate(response.delivery_date);
						}
						resolve(returnData);
					} else {
						reject(response);
					}
				})
				.catch((error) => {
					console.log(error, "error");
					if (showLoading) {
						loading.dismiss();
					}
					reject(error);
				});
		});
	},

	getQuoteItems: async (showLoading = false, addReject = false) => {
		const loading = await createLoading(t("pleaseWait"));
		if (showLoading) {
			loading.present();
		}
		const mainStore = useMainStore();
		const cartStore = useCartStore();
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostRequest(settingsApp.getEndpointUrl("getQuoteItems"), {
					store_view: mainStore.storeCode,
				})
				.then((response: any) => {
					if (response.success) {
						const items = response.items;
						const cartItems: any = {};
						let finishedProc = 0;
						for (let i = 0; i < items.length; i++) {
							const item = items[i];
							cartItems["prd_" + item.product_id] = {
								qty: item.qty,
								product_id: item.product_id,
								item_id: item.item_id,
								item: item,
								batch_order: item.batch_order,
							};
							finishedProc++;
							if (finishedProc == items.length) {
								cartStore.setCartItems(cartItems);
								resolve(response.items);
							}
						}
					} else {
						cartStore.setCartItems([]);
						if (addReject) reject(response);
					}
					if (showLoading) {
						loading.dismiss();
					}
				})
				.catch((error) => {
					if (showLoading) {
						loading.dismiss();
					}
					if (addReject) reject(error);
				});
		});
	},

	addToCart: async (data: any, showLoading = false, silent = false) => {
		const loading = await createLoading(t("pleaseWait"));
		if (showLoading) {
			loading.present();
		}
		const cartStore = useCartStore();
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostRequest(settingsApp.getEndpointUrl("addToCart"), data)
				.then((response: any) => {
					if (showLoading) {
						loading.dismiss();
					}
					if (
						!Object.prototype.hasOwnProperty.call(response, "error")
					) {
						const item = response.item;
						const cartItems = cartStore.cartItems;
						cartItems[
							"prd_" + data.product_id + "item_" + item.item_id
						] = {
							qty: item.qty,
							product_id: item.product_id,
							item_id: item.item_id,
							item: item,
							batch_order: item.batch_order,
						};
						cartStore.setCartItems(cartItems);
						resolve(response);
					} else {
						if (!silent) {
							if (
								te("apiMessages.codes." + response.error.code)
							) {
								openToast(
									t(
										"apiMessages.codes." +
											response.error.code
									),
									"danger"
								);
							} else {
								openToast(response.error.message, "danger");
							}
						}
						reject(response);
					}
				})
				.catch((error) => {
					if (showLoading) {
						loading.dismiss();
					}
					reject(error);
				});
		});
	},
	updateCartQty: async (
		product: any,
		qty: any,
		delivery_date = null,
		showLoading = false,
		silent = false
	) => {
		const loading = await createLoading(t("pleaseWait"));
		if (showLoading) {
			loading.present();
		}
		const cartStore = useCartStore();
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostRequest(
					settingsApp.getEndpointUrl("updateQuantityById"),
					{
						item_id:
							cartStore.cartItems["prd_" + product.entity_id][
								"item_id"
							],
						qty: qty,
						delivery_date: delivery_date,
					}
				)
				.then((response: any) => {
					if (showLoading) {
						loading.dismiss();
					}
					if (
						!Object.prototype.hasOwnProperty.call(response, "error")
					) {
						const item = response.item;
						const cartItems = cartStore.cartItems;
						cartItems["prd_" + product.entity_id] = {
							qty: item.qty,
							item_id: item.item_id,
							item: item,
							batch_order: item.batch_order,
						};
						cartStore.setCartItems(cartItems);
						//cartStore.setCartCount(cartItems.length);
						resolve(response);
					} else {
						if (!silent) {
							if (
								te("apiMessages.codes." + response.error.code)
							) {
								openToast(
									t(
										"apiMessages.codes." +
											response.error.code
									),
									"danger"
								);
							} else {
								openToast(response.error.message, "danger");
							}
						}
						reject(response);
					}
				})
				.catch((error) => {
					if (showLoading) {
						loading.dismiss();
					}
					reject(error);
				});
		});
	},
	removeFromCart: async (
		itemId: any,
		productId: any,
		showLoading = false,
		silent = false
	) => {
		const loading = await createLoading(t("pleaseWait"));
		if (showLoading) {
			loading.present();
		}
		const cartStore = useCartStore();
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostRequest(
					settingsApp.getEndpointUrl("removeItemCartById"),
					{
						item_id: itemId,
					}
				)
				.then((response: any) => {
					if (showLoading) {
						loading.dismiss();
					}
					if (
						!Object.prototype.hasOwnProperty.call(response, "error")
					) {
						const cartItems = cartStore.cartItems;
						delete cartItems["prd_" + productId + "item_" + itemId];
						cartStore.setCartItems(cartItems);
						resolve(response);
					} else {
						if (!silent) {
							if (
								te("apiMessages.codes." + response.error.code)
							) {
								openToast(
									t(
										"apiMessages.codes." +
											response.error.code
									),
									"danger"
								);
							} else {
								openToast(response.error.message, "danger");
							}
						}
						reject(response);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	clearCart: async (showLoading = false, silent = false) => {
		const loading = await createLoading(t("pleaseWait"));
		if (showLoading) {
			loading.present();
		}
		const cartStore = useCartStore();
		return new Promise(function (resolve, reject) {
			const ids = [];
			Object.keys(cartStore.cartItems).forEach((key) => {
				ids.push(cartStore.cartItems[key].item_id);
			});
			httpApp
				.sendPostRequest(
					settingsApp.getEndpointUrl("removeItemsCart"),
					{
						remove: ids,
					}
				)
				.then((response: any) => {
					if (showLoading) {
						loading.dismiss();
					}
					if (
						!Object.prototype.hasOwnProperty.call(response, "error")
					) {
						resolve(response);
					} else {
						if (!silent) {
							if (
								te("apiMessages.codes." + response.error.code)
							) {
								openToast(
									t(
										"apiMessages.codes." +
											response.error.code
									),
									"danger"
								);
							} else {
								openToast(response.error.message, "danger");
							}
						}
						reject(response);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	updateItemsCart: async (
		cartItemsQtyData: any,
		showLoading = false,
		silent = false
	) => {
		const loading = await createLoading(t("pleaseWait"));
		if (showLoading) {
			loading.present();
		}
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostRequest(
					settingsApp.getEndpointUrl("updateItemsCart"),
					{
						cart: cartItemsQtyData,
					}
				)
				.then((response: any) => {
					if (showLoading) {
						loading.dismiss();
					}
					if (
						!Object.prototype.hasOwnProperty.call(response, "error")
					) {
						resolve(response);
					} else {
						if (!silent) {
							if (
								te("apiMessages.codes." + response.error.code)
							) {
								openToast(
									t(
										"apiMessages.codes." +
											response.error.code
									),
									"danger"
								);
							} else {
								openToast(response.error.message, "danger");
							}
						}
						reject(response);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	applyPromoCode: async (
		couponCode: any,
		showLoading = false,
		silent = false
	) => {
		const loading = await createLoading(t("pleaseWait"));
		if (showLoading) {
			loading.present();
		}
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostRequest(settingsApp.getEndpointUrl("applyPromoCode"), {
					coupon_code: couponCode,
				})
				.then((response: any) => {
					if (showLoading) {
						loading.dismiss();
					}
					if (
						!Object.prototype.hasOwnProperty.call(response, "error")
					) {
						resolve(response);
					} else {
						if (!silent) {
							if (
								te("apiMessages.codes." + response.error.code)
							) {
								openToast(
									t(
										"apiMessages.codes." +
											response.error.code
									),
									"danger"
								);
							} else {
								openToast(response.error.message, "danger");
							}
						}
						reject(response);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	setSearchedPostcode: async (postcode: any) => {
		return new Promise(function (resolve, reject) {
			httpApp
				.sendPostRequest(
					settingsApp.getEndpointUrl("setSearchedPostcode"),
					{
						postcode: postcode,
					}
				)
				.then((response: any) => {
					if (
						!Object.prototype.hasOwnProperty.call(response, "error")
					) {
						resolve(response);
					} else {
						reject(response);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};

export default cartApp;
